import { API_URL } from '../config/connect';

export const getUserInvoices = async (page = 1, limit = 20) => {
    const accessToken = localStorage.getItem('access_token');
    if (!accessToken) throw new Error('Access token missing');

    const res = await fetch(`${API_URL}/api/v1/invoices?page=${page}&limit=${limit}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: 'application/json',
        },
    });
    if (!res.ok) throw new Error(`Error ${res.status}`);
    return res.json();
};

export const createInvoice = async (invoiceData) => {
    const accessToken = localStorage.getItem('access_token');
    if (!accessToken) throw new Error('Access token missing');

    const res = await fetch(`${API_URL}/api/v1/invoices/`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(invoiceData),
    });
    if (!res.ok) {
        const text = await res.text();
        throw new Error(text || `Error ${res.status}`);
    }
    return res.json();
};
